export default {
    generic: {
        poweredBy: "Powered by",
        topLevelErrorBoundary: "Oops! Something went wrong! Please contact support if this issue persists.",
        viewMode: {
            table: "Table",
            list: "List",
            grid: "Grid"
        },
        actions: {
            toCart: "Add to Cart",
            explore: "Explore",
            remove: "Remove"
        }
    },
    decisionTree: {
        quoteBuilder: {
            previousQuestion: "Previous Question",
            nextQuestion: "Next Question",
            startOver: "Start Over",
            goBack: "Go Back",
            buildQuoteHeader: "Build Quote",
            buildQuote: "Build Quote",
            form: {
                description: "Just fill out the rest of the infomation below and we can generate your proposal.",
                theBasics: "The Basics",
                anythingElse: "Anything else we should know?",
                addHere: "Add here"
            },
            errors: {
                buildQuote: "An error occurred while building your quote"
            }
        }
    },
    proposalGeneration: {
        generateProposal: "Generate Proposal",
        sendToVms: "Send to VMS",
        salesForce: "Submit to Salesforce",
        asAPdf: "As a PDF Doc",
        asAWord: "As a Word Doc",
        saveForLater: "Save for later",
        form: {
            desiredStartDate: "Desired Start Date",
            name: "Name",
            company: "Company",
            email: "Email",
            totalPrice: "Total Price",
            totalPriceInPoints: "Total Credits",
            companyAddress: "Street Address",
            city: "City",
            state: "State",
            postalCode: "Postal Code",
            country: "Country"
        }
    },
    productDetails: {
        viewQuote: "View Quote",
        addToOrder: "Add to order",
        addAnotherToOrder: "Add Another",
        addedToOrder: "Added to order",
        submitRequest: "Submit Request",
        addToSOW: "Add to SOW",
        addedToSOW: "Added to SOW",
        loadingError: "An error occurred while loading the products",
        invalidFields: "Some fields are invalid",
        startOver: "Start Over",
        rows: {
            documents: {
                asset: "Asset",
                name: "Name",
                description: "Description",
                lastUpdated: "Last Updated",
                noDocuments: "There are no documents to be displayed."
            }
        }
    },
    productList: {
        loadingError: "An error occurred while loading the products",
        noItemsFound: "No Items Found",
        configure: "Configure",
        priceFilterLabel: "Filter items by Credits"
    },
    product: {
        noProductError: "No Product Found"
    },
    modal: {
        confirmation: {
            confirmation: "Confirmation",
            yes: "Yes",
            no: "No"
        }
    },
    toolbar: {
        searchPlaceholder: "Search...",
        filterByCategory: "Filter by category"
    },
    proposals: {
        removeProposalsConfirmation: "Are you sure you would like to delete this item?",
        archiveProposalsConfirmation: "Are you sure you would like to archive this item?",
        loadingError: "An error occurred while loading the proposals",
        noProposalsError: "You have no proposals currently.",
        noProposalsMessage: "There are no proposals to be displayed",
        columns: {
            name: "Proposal Name",
            clientName: "Client Name",
            created: "Created",
            createdBy: "Created By",
            createdDate: "Create Date",
            value: "Value",
            status: "Status",
            expiration: "Expiration",
            actions: "Actions",
            servicesTotal: "Services total"
        },
        actions: {
            delete: "Delete",
            approve: "Approve",
            sendForApprovals: "Send for Approval",
            archive: "Archive",
            reject: "Reject"
        },
        status: {
            asQuoteWord: "As Word Quote",
            asQuotePdf: "As PDF Quote"
        }
    },
    samePageProposalBuilder: {
        form: {
            title: "Your Details & Information"
        }
    },
    sso: {
        popupBlockedMessage: "The application failed to open a pop-up window, please disable any pop-up blockers on this page and refresh your browser."
    }
};
